import { c as _c } from "react/compiler-runtime";
import { format, getDay, getMonth, getYear, isBefore, isEqual, startOfDay } from 'date-fns';
import { type CalendarEvent, Event } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import { WEEK_DAYS } from './HourSelector';
type SelectedEventsByWeekDay = Record<WEEK_DAYS, string[]>;
interface EventListProps {
  eventsForSelectedDay: Map<string, CalendarEvent[]>;
  selectedEventsMap: Map<string, CalendarEvent[]>;
  setSelectedEventsMap: React.Dispatch<React.SetStateAction<Map<string, CalendarEvent[]>>>;
  selectedDay: Date;
  selectedHoursByDay: SelectedEventsByWeekDay;
  // setSelectedHoursByDay: React.Dispatch<React.SetStateAction<SelectedEventsByWeekDay>>
  excludedRecurringEvents: Set<string>;
  setExcludedRecurringEvents: React.Dispatch<React.SetStateAction<Set<string>>>;
}
export function EventList(t0) {
  const $ = _c(37);
  const {
    eventsForSelectedDay,
    selectedEventsMap,
    setSelectedEventsMap,
    selectedDay,
    selectedHoursByDay,
    excludedRecurringEvents,
    setExcludedRecurringEvents
  } = t0;
  let currentMonth;
  let currentYear;
  let t1;
  if ($[0] !== selectedDay) {
    const today = startOfDay(new Date());
    currentMonth = getMonth(today);
    currentYear = getYear(today);
    t1 = isEqual(startOfDay(selectedDay), today);
    $[0] = selectedDay;
    $[1] = currentMonth;
    $[2] = currentYear;
    $[3] = t1;
  } else {
    currentMonth = $[1];
    currentYear = $[2];
    t1 = $[3];
  }
  const isToday = t1;
  let t2;
  if ($[4] !== selectedDay) {
    t2 = getMonth(selectedDay);
    $[4] = selectedDay;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const selectedDayMonth = t2;
  let t3;
  if ($[6] !== selectedDay) {
    t3 = getYear(selectedDay);
    $[6] = selectedDay;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const selectedDayYear = t3;
  let t4;
  let t5;
  if ($[8] !== currentMonth || $[9] !== currentYear || $[10] !== eventsForSelectedDay || $[11] !== excludedRecurringEvents || $[12] !== isToday || $[13] !== selectedDay || $[14] !== selectedDayMonth || $[15] !== selectedDayYear || $[16] !== selectedEventsMap || $[17] !== selectedHoursByDay || $[18] !== setExcludedRecurringEvents || $[19] !== setSelectedEventsMap) {
    let t6;
    if ($[22] !== isToday) {
      t6 = event => {
        if (!isToday) {
          return true;
        }
        const isPast = isBefore(event.startTime, new Date());
        if (isPast && !event.isBooked) {
          return false;
        }
        return true;
      };
      $[22] = isToday;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    const events = [...eventsForSelectedDay.values()].flat().filter(t6);
    const dayOfWeek = getDay(selectedDay);
    const adjustedDayIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    const selectedDayName = Object.values(WEEK_DAYS)[adjustedDayIndex];
    const recurringHoursForSelectedDay = selectedHoursByDay[selectedDayName];
    t4 = "custom-scrollbar grid max-h-120 grid-cols-3 gap-3 overflow-y-auto sm:grid-cols-5";
    let t7;
    if ($[24] !== currentMonth || $[25] !== currentYear || $[26] !== excludedRecurringEvents || $[27] !== recurringHoursForSelectedDay || $[28] !== selectedDayMonth || $[29] !== selectedDayYear || $[30] !== selectedEventsMap || $[31] !== setExcludedRecurringEvents || $[32] !== setSelectedEventsMap) {
      t7 = event_0 => {
        const formattedDay = format(event_0.startTime, "yyyy.MM.dd");
        const eventHour = format(event_0.startTime, "HH:mm");
        const exclusionKey = `${formattedDay}-${eventHour}`;
        const isInCurrentMonth = selectedDayMonth === currentMonth && selectedDayYear === currentYear;
        const isRecurringHour = isInCurrentMonth && recurringHoursForSelectedDay.includes(eventHour);
        const isExcluded = excludedRecurringEvents.has(exclusionKey);
        const isRecurringFromDatabase = isInCurrentMonth && (event_0.isRecurring ?? false);
        const isManuallySelected = selectedEventsMap.get(formattedDay)?.some(e => isEqual(e.startTime, event_0.startTime) && !e.isRecurring) ?? false;
        const isRecurringSelected = (isRecurringHour || isRecurringFromDatabase) && !isExcluded;
        const isSelected = isManuallySelected || isRecurringSelected;
        return <Event key={event_0.id} event={event_0} isChecked={isSelected} isRecurring={isRecurringSelected} handleSelectedEvent={() => {
          if (event_0.isBooked) {
            return;
          }
          if ((isRecurringHour || isRecurringFromDatabase) && !isExcluded) {
            setExcludedRecurringEvents(prev => {
              const newSet = new Set(prev);
              newSet.add(exclusionKey);
              return newSet;
            });
            return;
          }
          if ((isRecurringHour || isRecurringFromDatabase) && isExcluded) {
            setExcludedRecurringEvents(prev_0 => {
              const newSet_0 = new Set(prev_0);
              newSet_0.delete(exclusionKey);
              return newSet_0;
            });
            return;
          }
          setSelectedEventsMap(prev_1 => {
            const newMap = new Map(prev_1);
            const existing = newMap.get(formattedDay) ?? [];
            if (isManuallySelected) {
              newMap.set(formattedDay, existing.filter(e_0 => !isEqual(e_0.startTime, event_0.startTime)));
            } else {
              newMap.set(formattedDay, [...existing, event_0]);
            }
            return newMap;
          });
        }} />;
      };
      $[24] = currentMonth;
      $[25] = currentYear;
      $[26] = excludedRecurringEvents;
      $[27] = recurringHoursForSelectedDay;
      $[28] = selectedDayMonth;
      $[29] = selectedDayYear;
      $[30] = selectedEventsMap;
      $[31] = setExcludedRecurringEvents;
      $[32] = setSelectedEventsMap;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    t5 = events.map(t7);
    $[8] = currentMonth;
    $[9] = currentYear;
    $[10] = eventsForSelectedDay;
    $[11] = excludedRecurringEvents;
    $[12] = isToday;
    $[13] = selectedDay;
    $[14] = selectedDayMonth;
    $[15] = selectedDayYear;
    $[16] = selectedEventsMap;
    $[17] = selectedHoursByDay;
    $[18] = setExcludedRecurringEvents;
    $[19] = setSelectedEventsMap;
    $[20] = t4;
    $[21] = t5;
  } else {
    t4 = $[20];
    t5 = $[21];
  }
  let t6;
  if ($[34] !== t4 || $[35] !== t5) {
    t6 = <section className={t4}>{t5}</section>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  return t6;
}